import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=60e5c099&scoped=true"
import script from "./Thanks.vue?vue&type=script&lang=js"
export * from "./Thanks.vue?vue&type=script&lang=js"
import style0 from "./Thanks.vue?vue&type=style&index=0&id=60e5c099&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e5c099",
  null
  
)

export default component.exports